import theme from '../../theme/theme';

const {
  colors: { remove_icon, menu_icon, position_icon, blue_purple_button, white_text },
} = theme;

const styles = {
  list__container: {
    padding: '8% 8% 0 8%',
  },

  menu__icon: {
    fontSize: '30px',
    color: menu_icon,
  },

  position__icon: {
    fontSize: '30px',
    color: position_icon,
  },

  remove_icon: {
    right: '8%',
    fontSize: '30px',
    color: remove_icon,
  },

  list__title: {
    fontSize: '1.5em',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  },

  save__button: {
    display: 'flex',
    flex: 1,
    borderRadius: '0',
    background: blue_purple_button,
    height: '5em',
  },

  save__text: {
    fontSize: '1.5em',
    textTransform: 'capitalize',
    fontFamily: 'semibold',
    color: white_text,
  },

  footer: {
    display: 'flex',
    flex: 1,
    width: '100%',
    position: 'absolute',
    bottom: 0,
  },
};

export default styles;
